export default "/image-banner-empty.b8b94d42-f5cad3.png";